import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "webhook-container card shadow-sm" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "col-md-9" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-hover align-middle mb-0" }
const _hoisted_11 = { class: "text-break font-monospace small text-primary" }
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }

import { ref, onMounted } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import Swal from "sweetalert2";


export default /*@__PURE__*/_defineComponent({
  __name: 'WebhookSettings',
  setup(__props) {

const { showToast } = useAppToast();
const webhooks = ref([]);
const url = ref("");
const isLoading = ref(false);

async function fetchWebhooks() {
  try {
    const res = await api.get("/api/auth/client/webhooks");
    webhooks.value = res.data;
  } catch (e) {
    showToast("Failed to load webhooks", "error");
  }
}

async function addWebhook() {
  if (!url.value) return;

  isLoading.value = true;
  try {
    await api.post("/api/auth/client/webhooks", { url: url.value });
    showToast("Webhook endpoint added successfully", "success");
    url.value = "";
    await fetchWebhooks();
  } catch (e: any) {
    showToast(e.response?.data?.message || "Error adding webhook", "error");
  } finally {
    isLoading.value = false;
  }
}

async function confirmDelete(id: number) {
  Swal.fire({
    text: "Êtes-vous sûr de vouloir supprimer ce webhook ? Vous ne recevrez plus d'événements à cette URL.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimer!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      await api.delete(`/api/webhooks/${id}`);
    }
  });
}

async function removeWebhook(id: number) {
  //   try {
  //     await webhookService.remove(id);
  //     showToast("Webhook removed", "success");
  //     fetchWebhooks();
  //   } catch (e) {
  //     showToast("Error deleting webhook", "error");
  //   }
}

onMounted(fetchWebhooks);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header bg-white py-3" }, [
      _createElementVNode("h5", { class: "mb-1 fw-bold" }, "Configuration des webhooks"),
      _createElementVNode("p", { class: "text-muted small mb-0" }, " Mise en place d’un webhook permettant la synchronisation en temps réel des statuts des colis avec des services externes. ")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"d-flex flex-wrap gap-2 mb-3\" data-v-fbd9c0f8><span class=\"badge bg-light text-dark border px-3 py-2\" data-v-fbd9c0f8><i class=\"bi bi-send-fill me-1 text-primary\" data-v-fbd9c0f8></i> Method: <b data-v-fbd9c0f8>POST</b></span><span class=\"badge bg-light text-dark border px-3 py-2\" data-v-fbd9c0f8><i class=\"bi bi-code-slash me-1 text-primary\" data-v-fbd9c0f8></i> Content-Type: <b data-v-fbd9c0f8>application/json</b></span></div><div class=\"mb-4\" data-v-fbd9c0f8><div class=\"p-3 bg-light rounded border border-info-subtle\" data-v-fbd9c0f8><div class=\"d-flex justify-content-between align-items-center mb-2\" data-v-fbd9c0f8><h6 class=\"mb-0 fw-bold\" data-v-fbd9c0f8><i class=\"bi bi-info-circle-fill text-info me-2\" data-v-fbd9c0f8></i>Documentation Technique</h6></div><p class=\"small text-muted mb-2\" data-v-fbd9c0f8>Payload JSON envoyé à votre URL :</p><div class=\"table-responsive bg-white rounded shadow-sm border\" data-v-fbd9c0f8><table class=\"table table-sm table-hover mb-0\" data-v-fbd9c0f8><thead class=\"table-light\" data-v-fbd9c0f8><tr class=\"small\" data-v-fbd9c0f8><th class=\"ps-3\" data-v-fbd9c0f8>Clé (Key)</th><th data-v-fbd9c0f8>Description</th></tr></thead><tbody class=\"small\" data-v-fbd9c0f8><tr data-v-fbd9c0f8><td class=\"ps-3\" data-v-fbd9c0f8><code class=\"text-danger\" data-v-fbd9c0f8>codeColis</code></td><td class=\"text-secondary\" data-v-fbd9c0f8>Le numéro de suivi unique</td></tr><tr data-v-fbd9c0f8><td class=\"ps-3\" data-v-fbd9c0f8><code class=\"text-danger\" data-v-fbd9c0f8>status</code></td><td class=\"text-secondary\" data-v-fbd9c0f8>Le statut actuel de l&#39;envoi</td></tr><tr data-v-fbd9c0f8><td class=\"ps-3\" data-v-fbd9c0f8><code class=\"text-danger\" data-v-fbd9c0f8>situation</code></td><td class=\"text-secondary\" data-v-fbd9c0f8>Situation géographique ou étape</td></tr><tr data-v-fbd9c0f8><td class=\"ps-3\" data-v-fbd9c0f8><code class=\"text-danger\" data-v-fbd9c0f8>note</code></td><td class=\"text-secondary\" data-v-fbd9c0f8>Commentaire ou motif</td></tr></tbody></table></div></div></div>", 2)),
      _createElementVNode("form", {
        onSubmit: _withModifiers(addWebhook, ["prevent"]),
        class: "row g-2 mb-4"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "input-group-text bg-light" }, [
              _createElementVNode("i", { class: "bi bi-link-45deg" })
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((url).value = $event)),
              type: "url",
              required: "",
              class: "form-control",
              placeholder: "https://your-api.com/webhook-endpoint",
              disabled: isLoading.value
            }, null, 8, _hoisted_5), [
              [_vModelText, url.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "btn btn-primary w-100",
            disabled: isLoading.value || !url.value
          }, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(isLoading.value ? "Enregistrement..." : "Ajouter un endpoint"), 1)
          ], 8, _hoisted_7)
        ])
      ], 32),
      _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "my-4 opacity-25" }, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _cache[4] || (_cache[4] = _createElementVNode("thead", { class: "table-light" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "border-0" }, "URL cible"),
              _createElementVNode("th", {
                class: "border-0 text-end",
                width: "150"
              }, "Actions")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(webhooks.value, (hook) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: hook.id
              }, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(hook.url), 1),
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-danger btn-sm border-0",
                    onClick: ($event: any) => (confirmDelete(hook.id)),
                    title: "Supprimer le webhook"
                  }, _cache[2] || (_cache[2] = [
                    _createElementVNode("i", { class: "bi bi-trash3 me-1" }, null, -1),
                    _createTextVNode(" Supprimer ", -1)
                  ]), 8, _hoisted_13)
                ])
              ]))
            }), 128)),
            (webhooks.value.length === 0 && !isLoading.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_14, _cache[3] || (_cache[3] = [
                  _createElementVNode("td", {
                    colspan: "2",
                    class: "text-center py-5"
                  }, [
                    _createElementVNode("div", { class: "text-muted" }, [
                      _createElementVNode("i", { class: "bi bi-plug-fill display-6 mb-2 d-block" }),
                      _createElementVNode("p", null, "Aucun webhook configuré pour le moment.")
                    ])
                  ], -1)
                ])))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})